import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=1c2a4104&scoped=true&"
import script from "./footer-info.vue?vue&type=script&lang=js&"
export * from "./footer-info.vue?vue&type=script&lang=js&"
import style0 from "./footer-info.vue?vue&type=style&index=0&id=1c2a4104&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2a4104",
  null
  
)

export default component.exports